import { Component, EventEmitter, Output } from "@angular/core";
import { NavigationService } from "src/services/navigation/navigation.service";
import { MessageService } from "src/services/message/message.service";
import { isVehicleQrCode } from "src/services/qr-code/qr-code.interface";
import { Vehicle } from "src/services/item/vehicle.interface";

@Component({
  selector: "rc-vehicle-scanner",
  templateUrl: "./vehicle-scanner.component.html",
  styleUrls: ["./vehicle-scanner.component.scss"],
  standalone: false,
})
export class VehicleScannerComponent {
  @Output() public onQrCodeScanned = new EventEmitter<Vehicle>();

  private processingCode = false;

  constructor(
    public readonly navigationService: NavigationService,
    private readonly messageService: MessageService,
  ) {}

  public async tryHandleQrCodeScanned(qrCodeString: string): Promise<void> {
    if (this.processingCode) {
      return;
    }

    this.processingCode = true;
    try {
      this.onQrCodeScanned.emit(await this.getVehicleFromQrCodeOrThrow(qrCodeString));
    } catch (error) {
      await this.messageService.presentErrorToast(error.message);
    } finally {
      this.processingCode = false;
    }
  }

  private async getVehicleFromQrCodeOrThrow(qrCodeString: string): Promise<Vehicle> {
    let qrCode: unknown;
    try {
      qrCode = JSON.parse(qrCodeString);
    } catch {
      await this.messageService.presentErrorToast("This QR code can't be read");
    }

    if (!isVehicleQrCode(qrCode)) {
      throw new Error("This QR code doesn't contain vehicle information");
    }

    return qrCode;
  }
}
